import styles from "./index.module.scss";
import Image from "next/image";
import { Layout, Tooltip } from "antd";
import { useLayoutEffect, useState } from "react";
import { cdnHost, version } from "@/utils";
import { useTranslation } from "next-i18next";
import classNames from "classnames";
import { usePathname } from "next/navigation"; // App Router (Next.js 13+)
import { clickEvent, track } from "@/sdk/sensors";
import SelectAccount from "./select-account";
import { useRouter } from "next/router";
import SelectComponent from "@/i18n/selectComponent";
// import { PhoneOutlined } from "@ant-design/icons";

const { Header } = Layout;

export default function PublicHeader(props: any) {
  const { t } = useTranslation();
  // const { changeLanguage } = useChangeLanguage(); // 切换语言自定义hooks
  const pathname = usePathname();
  // const [token, setToken] = useState("");
  const [open, setOpen] = useState(false);

  const router = useRouter();

  const goRouterUrl = (url: string) => {
    router.push(url); // 跳转到 指定页面
  };

  // const options = MenuList().map(item => ({
  //   key: item.key,
  //   label: item.label
  // }));
  // useEffect(() => {
  //   // 刷新后动态渲染tab
  //   if (pathname.includes("about")) {
  //     setCurrentTab("about");
  //   } else {
  //     setCurrentTab("home");
  //   }
  // }, [pathname]);

  // useEffect(() => {
  //   // sso 不能用在服务端判断，服务端获取的数据最好不要涉及登录
  //   void getToken(callback);
  //   setToken(getStorage(STORAGE_TYPE.TOKEN));
  //   // updateI18n();
  // }, []);

  // 获取sso回调链接的语言参数 用于切换语言
  // const updateI18n = (): void => {
  //   const locale = getUrlParam("locale");
  //   if (isNotEmptyString(locale)) {
  //     changeLanguage(locale ?? "zh");
  //   }
  // };

  // const callback = (jwt: string): void => {
  //   // 及时获取token，用于是否显示登录登出
  //   setToken(jwt);

  //   // 获取用户信息
  //   getAuth();
  // };

  // "code2015": "获取用户信息失败",
  // "code40004": "用户状态异常",
  // "axios-error": "亲，服务器开小差了",
  // 获取用户信息
  // const getAuth = async (): Promise<void> => {
  //   const { data } = await apiClientMethods.getUserInfo();
  //   console.log(data);
  //   // 可以用状态管理
  // };

  // 登录
  const gohref = () => {
    setOpen(true);
    // sso
    // ssoHref(i18n.language);
    // 埋点
    track(clickEvent.login_webclick);
  };
  const [menuOpen, setMenuOpen] = useState(false); // 新增控制菜单展开/折叠的状态

  // 切换菜单显示状态
  // const toggleMenu = () => {
  //   setMenuOpen(!menuOpen);
  // };
  // 首页背景透明，其它也背景为白色
  const [isScrolled, setIsScrolled] = useState(pathname !== "/"); // 新增状态

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    if (pathname === "/") {
      setIsScrolled(false);
      // 添加滚动事件监听器
      window.addEventListener("scroll", handleScroll);
    } else {
      setIsScrolled(true);
    }

    // 在组件卸载时移除监听器
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pathname]);

  return (
    <Header className={classNames(styles["init-header"], isScrolled && styles.actived)}>
      <div className="zhan-wei"></div>
      <div className={classNames("header", isScrolled && "actived")}>
        <div className="logo">
          <Image
            className="logo-img"
            src={
              isScrolled
                ? `${cdnHost}image/web-site/logo-active.png?v=${version}`
                : `${cdnHost}image/web-site/logo.png?v=${version}`
            }
            alt="logo"
            width={572}
            height={94}
          />
        </div>
        <div className="flex"></div>
        {/* 汉堡菜单按钮，小屏幕时显示 */}
        {/* <div className="hamburger-menu" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div> */}
        {/* 导航菜单，使用条件类控制显示 */}
        <div className={classNames("nav-menu", { "menu-open": menuOpen })}>
          <div
            onClick={() => {
              if (pathname === "/") return;
              track(clickEvent.header_home_click);
              // window.open("/");
              goRouterUrl("/");
              setMenuOpen(false); // 点击后关闭菜单
            }}
            className={classNames("menu-content", pathname === "/" && "active no-hover")}
          >
            <p>
              {t("shou-ye")}
              <span></span>
            </p>
          </div>
          <Tooltip
            getPopupContainer={triggerNode => triggerNode.parentNode as HTMLElement}
            arrow={false}
            placement="bottom"
            align={{ offset: [0, 6] }} // 水平不偏移，垂直向下偏移6px
            title={
              <div className={classNames("animate__animated", "animate__fadeIn", "animate__fast")}>
                <p
                  className={pathname === "/demand" ? "path-active" : ""}
                  onClick={() => {
                    if (pathname === "/demand") return;
                    track(clickEvent.header_demand_click);
                    // window.open("/demand");
                    goRouterUrl("/demand");
                    setMenuOpen(false); // 点击后关闭菜单
                  }}
                >
                  {t("xu-qiu-fang")}
                </p>
                <p
                  className={pathname === "/provider" ? "path-active" : ""}
                  onClick={() => {
                    if (pathname === "/provider") return;
                    track(clickEvent.header_provision_click);
                    // window.open("/provider");
                    goRouterUrl("/provider");
                    setMenuOpen(false); // 点击后关闭菜单
                  }}
                >
                  {t("fu-wu-shang")}
                </p>
              </div>
            }
            overlayClassName={styles.tooltip}
          >
            <div
              className={classNames(
                "menu-content",
                "menu-content-plat",
                (pathname === "/demand" || pathname === "/provider") && "active"
              )}
            >
              <p>
                {t("yu-yan-fu-wu")}
                <span></span>
              </p>
            </div>
          </Tooltip>

          <div
            onClick={() => {
              if (pathname === "/regarding") return;
              track(clickEvent.header_regarding_click);
              // window.open("/regarding");
              goRouterUrl("/regarding");
              setMenuOpen(false); // 点击后关闭菜单
            }}
            className={classNames(
              "menu-content",
              "menu-content-plat",
              pathname === "/regarding" && "active"
            )}
          >
            <p>
              {t("guan-yu-ping-tai")}
              <span></span>
            </p>
          </div>

          <Tooltip
            arrow={false}
            // 使用getPopupContainer属性来指定tooltip内容应该被渲染到的父容器 防止抖动
            getPopupContainer={triggerNode => triggerNode.parentNode as HTMLElement}
            placement="bottomRight"
            align={{ offset: [0, 6] }} // 水平不偏移，垂直向下偏移6px
            title={
              <div
                className={classNames(
                  "contact-us",
                  "animate__animated",
                  "animate__fadeIn",
                  "animate__fast"
                )}
              >
                <div className="cert-trans-img">
                  <Image
                    src={`${cdnHost}image/web-site/cert-trans.jpeg?v=${version}`}
                    alt="logo"
                    width={215}
                    height={215}
                  />
                </div>
              </div>
            }
            overlayClassName={styles.contact}
          >
            <div className={classNames("menu-content", "menu-content-plat", "menu-shopping")}>
              <p>{t("zheng-zhao-fan-yi")}</p>
            </div>
          </Tooltip>

          <Tooltip
            arrow={false}
            // 使用getPopupContainer属性来指定tooltip内容应该被渲染到的父容器 防止抖动
            getPopupContainer={triggerNode => triggerNode.parentNode as HTMLElement}
            placement="bottomRight"
            align={{ offset: [0, 6] }} // 水平不偏移，垂直向下偏移6px
            title={
              <div
                className={classNames(
                  "contact-us",
                  "animate__animated",
                  "animate__fadeIn",
                  "animate__fast"
                )}
              >
                <p>{t("ke-fu-dian-hua")}：400-898-7008</p>
                {/* <p>
                  <PhoneOutlined />
                  ：400-898-7008
                </p> */}
                <p>{t("yu-lao-shi")}：yufan@unipus.cn</p>
                <p>{t("wen-lao-shi")}：wenzhonghao@unipus.cn</p>
                <p>{t("bai-lao-shi")}：baiyunlong@unipus.cn</p>
                <p>{t("xing-lao-shi")}：xinghuanhuan@unipus.cn</p>
                <div className="contact-img">
                  <Image
                    src={`${cdnHost}image/web-site/header-contact.jpg?v=${version}`}
                    alt="logo"
                    width={164}
                    height={164}
                  />
                </div>
              </div>
            }
            overlayClassName={styles.contact}
          >
            <div className={classNames("menu-content-plat", "menu-content")}>
              {t("lian-xi-wo-men")}
            </div>
          </Tooltip>
          <div onClick={gohref} className={classNames("menu-content-plat", "menu-content")}>
            {t("deng-lu")}
          </div>
        </div>

        <SelectComponent />

        {/* {isNotEmptyString(token) && (
          <div onClick={exitSso} className={styles["login"]}>
            退出
          </div>
        )} */}
      </div>
      <div className="zhan-wei"></div>
      <SelectAccount
        open={open}
        cancel={() => {
          setOpen(false);
        }}
      />
    </Header>
  );
}
